import React, { createContext, useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { auth as setAuth } from '../../../app/slices/auth';
import Auth from '../../../api/repositories/auth';
import { initSocket, closeSocket } from '../../../app/slices/socketSlice';

interface AuthContextType {
  isAuthenticated: boolean;
  loading: boolean;
  login: (token: string) => void;
  logout: () => Promise<void>;
  checkAuth: () => Promise<boolean>;
}

const AuthContext = createContext<AuthContextType | null>(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const dispatch = useDispatch();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(
    localStorage.getItem('isAuthenticated') === 'true'
  );
  const [loading, setLoading] = useState<boolean>(true);

  // Проверка авторизации при загрузке
  useEffect(() => {
    const initAuth = async () => {
      const isAuth = await checkAuth();
      if (isAuth) {
        dispatch(initSocket());
      }
      setLoading(false);
    };

    initAuth();
  }, [dispatch]);

  const checkAuth = async (): Promise<boolean> => {
    if (localStorage.getItem('isAuthenticated') !== 'true') {
      setIsAuthenticated(false);
      dispatch(setAuth(false));
      return false;
    }

    try {
      const response = await Auth.verifyAuth();
      const isValid = response.status === 200;
      console.log(isValid);
      
      
      setIsAuthenticated(isValid);
      dispatch(setAuth(isValid));
      
      return isValid;
    } catch (error) {
      console.error('Auth check failed:', error);
      setIsAuthenticated(false);
      dispatch(setAuth(false));
      return false;
    }
  };

  const login = (token: string) => {
    localStorage.setItem('isAuthenticated', 'true');
    setIsAuthenticated(true);
    dispatch(setAuth(true));
    dispatch(initSocket());
  };

  const logout = async () => {
    try {
      await Auth.logout();
      localStorage.removeItem('isAuthenticated');
      setIsAuthenticated(false);
      dispatch(setAuth(false));
      dispatch(closeSocket());
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, loading, login, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}; 